import React, { Fragment, Component } from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';

export default class CustomerContactDetailsCard extends Component {
  render() {
    const { className, contactName, phone, email } = this.props;

    return (
      <Card className={cn(className, 'pa3')}>
        <h3 className="f4 mt0">Contact Details</h3>
        {contactName && (
          <Fragment>
            <p>
              <strong className="ttu">Contact: </strong> {contactName}
            </p>
          </Fragment>
        )}
        {phone && (
          <Fragment>
            <p>
              <strong className="ttu">Phone: </strong> <a href={`tel:${phone}`}>{phone}</a>
            </p>
          </Fragment>
        )}
        {email && (
          <Fragment>
            <p>
              <strong className="ttu">Email: </strong> <a href={`mailto:${email}`}>{email}</a>
            </p>
          </Fragment>
        )}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/customerContactDetailsCard/customerContactDetailsCard.jsx